import { toTimestamp } from '../utils/addWebSocketToReplication'
import { toISOString, toISOStringOrNull } from '../utils/pushSafetyUtils'
import { createReplication } from './createReplication'
import type { CustomFieldValueCollection } from '../index'

export const setupCustomFieldValueReplication = (
  collection: CustomFieldValueCollection,
  envId: string,
) =>
  createReplication({
    entityName: 'customfieldvalues',
    apiEntityName: 'custom-field-values',
    displayName: 'CustomFieldValue',
    collection,
    envId,
    mapFromServer: (doc) => ({
      id: doc.id,
      envId: doc.envId,
      taskId: doc.taskId || doc.workItemId,
      customFieldDefinitionId: doc.customFieldDefinitionId,
      stringValue: doc.stringValue ?? null,
      numberValue: doc.numberValue != null ? Number(doc.numberValue) : null,
      dateValue: doc.dateValue ? (toTimestamp(doc.dateValue) ?? new Date(doc.dateValue).getTime()) : null,
      isDeleted: doc.isDeleted || false,
      createdOn: toTimestamp(doc.createdOn) ?? new Date(doc.createdOn).getTime(),
      createdBy: doc.createdBy,
      updatedOn: toTimestamp(doc.updatedOn) ?? new Date(doc.updatedOn).getTime(),
      updatedBy: doc.updatedBy,
      deletedOn: doc.deletedOn ? (toTimestamp(doc.deletedOn) ?? new Date(doc.deletedOn).getTime()) : null,
      deletedBy: doc.deletedBy,
    }),
    mapToServer: (state, envId) => ({
      id: state.id,
      envId,
      taskId: state.taskId,
      customFieldDefinitionId: state.customFieldDefinitionId,
      stringValue: state.stringValue,
      numberValue: state.numberValue,
      dateValue: state.dateValue != null ? toISOString(state.dateValue) : null,
      isDeleted: state.isDeleted,
      createdOn: toISOString(state.createdOn),
      createdBy: state.createdBy,
      updatedOn: toISOString(state.updatedOn),
      updatedBy: state.updatedBy,
      deletedOn: toISOStringOrNull(state.deletedOn),
      deletedBy: state.deletedBy,
    }),
  })
